<template>
  <div>
    <!-- search input -->
<!--    <div class="custom-search d-flex">-->
<!--      <b-form-group>-->
<!--        <div class="d-flex align-items-center">-->
<!--          <label class="mr-1">{{ $t("general.search") }}</label>-->
<!--          <b-form-input-->
<!--            @input="searchUser"-->
<!--            v-model="searchTerm"-->
<!--            :placeholder="$t('general.search')"-->
<!--            type="text"-->
<!--            class="d-inline-block"-->
<!--          />-->
<!--        </div>-->
<!--      </b-form-group>-->
<!--    </div>-->
    <div class="white-section mt-2" style="padding: 10px 20px">
    <div class="d-flex justify-content-end" style="align-items: center">
      <div style="margin-left: auto" class="page-title">
        <b-breadcrumb-item
            v-for="item in breadcrumb"
            :key="item.text"
            :active="item.active"
            class="bread-crumb"
        >
          <!-- <div v-if="item.active">{{ item.translate ? $t(`navigation.${item.text}`) : item.text  }}</div> -->
          <!-- {{$route.meta}} -->
          <!-- {{ item.text }} -->
        </b-breadcrumb-item>
      </div>
    <div class="custom-search mb-0 d-flex w-100" style="box-shadow: none ; padding:10px 0">
      <b-form-group >
        <div class="d-flex align-items-center justify-content-start" style="width:600px">
          <b-form-input
              @input="searchUser"
              v-model="searchTerm"
              :placeholder="$t('general.search')"
              type="text"
              class="d-inline-block w-100 mw-100 mr-1"
          />
          <MyVSelect
              :options="this.userNational"
              v-model="searchedUserNational"
              :key="searchedUserNational"
              :concat-label="['text']"
              :reduce-field="['value']"
              custom-class="w-100 mr-2"
              @input="searchUser()"
              />
          <MyVSelect
            :options="genderSelection"
            v-model="searchedUserGender"
            :key="searchedUserGender + '-gender'"
            :concat-label="['text']"
            :reduce-field="['value']"
            custom-class="w-100 mr-3"
            @input="searchUser()"
        />
        </div>
      </b-form-group>
    </div>
      <!-- <router-link
        tag="button"
        :to="{ name: 'admission' }"
        class="btn btn-success btn-add"
        >{{ $t("general.add") }}</router-link
      > -->
    </div>
    <!-- table -->
    <vue-good-table
      v-if="patients"
      :columns="columns"
      :rows="patients"
      :pagination-options="{
        enabled: true,
        perPage: pageLength,
        mode: 'pages',
      }"
      class="user-table patient"
    >
      <template slot="table-column" slot-scope="props">
        <span v-if="props.column.label === 'action'" class="text-nowrap">
          {{ $t("general.action") }}
        </span>
        <span v-else-if="props.column.label === 'nationalCode'" class="text-nowrap">
        {{ $t(`user.${props.column.label}`) }} / {{ $t('user.nationality') }}
        </span>
        <span v-else>
          {{ $t(`user.${props.column.label}`) }}
        </span>
      </template>

      <!-- Slot: Table Row -->
      <template slot="table-row" slot-scope="props">
        <!-- Column: Name -->
        <span v-if="props.column.field === 'name'" class="text-nowrap">
          <span>{{ props.row.firstName }} {{ props.row.lastName }}</span>
        </span>
        <span v-else-if="props.column.field === 'nationalCode'" class="text-nowrap">
          <span > <span v-if="props.row.countryId && props.row.countryId.title.en === 'Iran'">{{ props.row.nationalCode }} / </span> <span v-if="props.row.countryId && props.row.countryId.title.fa">{{ props.row.countryId.title.fa }}</span></span>
        </span>
        <span v-else-if="props.column.field === 'action'">
              <span>
                 <b-dropdown
                    variant="link"
                    toggle-class="text-decoration-none"
                    no-caret
                >
                  <template v-slot:button-content>
                    <feather-icon
                        icon="MoreVerticalIcon"
                        size="16"
                        class="text-body align-middle mr-25"
                    />
                  </template>

                  <b-dropdown-item
                     @click="editPatient(props.row)"
                  >
                    <feather-icon icon="Edit2Icon" class="mr-50" />
                    <span>ویرایش بیمار</span>
                  </b-dropdown-item>

                  <b-dropdown-item
                  @click="showReference(props.row)"
                  >
                    <feather-icon icon="BookOpenIcon" class="mr-50" />
                    <span >مراجعات پیشین بیمار</span>
                  </b-dropdown-item>
                </b-dropdown> 
                <!-- <b-form-checkbox
                    @change="switchStatus($event, props.row)"
                    switch
                    inline
                    :checked="props.row.status === 'active'"
                >
                  {{ $t(`general.${props.row.status}`) }}
                </b-form-checkbox> -->
                <!-- <b-button
                class="btn btn-success"
                >
                  عملیات
                </b-button> -->
              </span>
            </span>
        <!-- Column: Common -->
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <!-- pagination -->
      <template slot="pagination-bottom" slot-scope="props">
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap">
              {{ $t("pagination.pageLength") }}
            </span>
            <b-form-select
              v-model="pageLength"
              :options="['20', '50', '100']"
              class="mx-1"
              @change="handlePageChange"
            />
            <span class="text-nowrap">
              <span class="text-nowrap">  {{ $t('general.of') }} {{ total }} {{ $t('general.pageText2') }} </span>
              <!-- {{ $t("pagination.pageText2") }} -->
            </span>
          </div>
          <div>
            <b-pagination
              v-model="page"
              :total-rows="total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @change="handlePageChange"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
    </div>
    <b-modal lazy v-model="isModalVisible">
      <LegacyModal  @close="closeModal" :user="selectedUser"/>
    </b-modal>
    <!-- modal refrence -->
    <div class="modal modalhistory refrance" tabindex="-1" v-if="showModalRefrence">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">مراجعات پیشین بیمار"{{ PatientName }}" </h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close"  @click="CloseReference">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <vue-good-table
                :columns="columnsRefrence"
                :rows="dataR"
              >
                <template slot="table-row" slot-scope="props">
                  <span v-if="props.column.field === 'dateTurn'" class="text-nowrap">
                    <div v-for="(item, index) in dataR" :key="index">
                    <span v-if="item._id === props.row._id" class="text-nowrap">
                      <span>{{ formatJalaliDate(item.date) }}</span>
                    </span>
                  </div>
                  </span>
                  <span v-if="props.column.field === 'timeTurn'" class="text-nowrap">
                    <div v-for="(item, index) in dataR" :key="index">
                    <span v-if="item._id === props.row._id" class="text-nowrap">
                      <span>{{ item.endTime }} - {{ item.fromTime }}</span>
                    </span>
                  </div>
                  </span>
                  <span v-if="props.column.field === 'nameDr'" class="text-nowrap">
                    <div v-for="(item, index) in dataR" :key="index">
                    <span v-if="item._id === props.row._id" class="text-nowrap">
                      <span>{{ item.planUserId.firstName }}  {{ item.planUserId.lastName }}</span>
                    </span>
                  </div>
                  </span>
                  <span v-if="props.column.field === 'unit'" class="text-nowrap">
                    <div  v-for="(unit, index) in unitTurn" :key="index">
                        <span v-if="props.row.unitId === unit._id">
                          {{ unit.title }}
                        </span>
                    </div>
                  </span>
                  <span v-if="props.column.field === 'user'" class="text-nowrap">
                    <div v-for="(item, index) in dataR" :key="index">
                    <span v-if="item._id === props.row._id" class="text-nowrap">
                      <span>{{ item.createdUserId.firstName }} {{ item.createdUserId.lastName }}</span>
                    </span>
                  </div>
                  </span>
                  <span v-if="props.column.field === 'action'" class="text-nowrap">
                    <span
                      v-if="!props.row.isDeleted && !props.row.updatedMoveAt && props.row.isCome === true"
                      class="badge badge-success"
                      >نوبت گرفته شده / مراجعه شده</span
                    >
                    <span
                      v-if="!props.row.isDeleted && !props.row.updatedMoveAt && props.row.isCome === false "
                      class="badge badge-info"
                      >نوبت گرفته شده </span
                    >
                    <span v-if="props.row.isDeleted === true && !props.row.updatedMoveAt" class="badge badge-danger">
                      حذف شده</span
                    >
                    <span v-else-if="props.row.updatedMoveAt" class="badge badge-warning">
                      انتقال داده شده</span
                    >
                    <!-- <span v-if="del">saa</span> -->
                  </span>
                  <span v-if="props.column.field === 'history'" class="text-nowrap">
                    <button @click="showHistory(props.row)" class="btn btn-outline-success" style="padding:5px">تاریخچه نوبت</button>
                  </span>
                </template>
              </vue-good-table>
            </div>
          </div>
        </div>
</div>
<!-- modal history -->
<div class="modal modalhistory" tabindex="-1" v-if="showModalDrag">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title"> تاریخچه نوبت بیمار "{{ PatientName }}" </h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close"  @click="closeModalHistory">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <vue-good-table
                :columns="columnsHistory"
                :rows="dataH"
              >
                <template slot="table-row" slot-scope="props">
                  <span v-if="props.column.field === 'date'" class="text-nowrap">
                    <span v-if="props.row.updatedMoveAt">
                      <div v-for="(item, index) in dataH" :key="index">
                        <span v-if="item._id === props.row._id" class="text-nowrap">
                          {{ formatJalaliDateUpdated(item.updatedMoveAt) }}
                        </span>
                      </div>
                    </span>
                    <span v-if="props.row.createdAt && !props.row.updatedMoveAt">
                      <div v-for="(item, index) in dataH" :key="index">
                        <span v-if="item._id === props.row._id" class="text-nowrap">
                          {{ formatJalaliDateCreated(item.createdAt) }}
                        </span>
                      </div>
                    </span>

                  </span>
                  <span v-if="props.column.field === 'dateTurn'" class="text-nowrap">
                    <div v-for="(item, index) in dataH" :key="index">
                    <span v-if="item._id === props.row._id" class="text-nowrap">
                      <span>{{ formatJalaliDate(item.date) }}</span>
                    </span>
                  </div>
                  </span>
                  <span v-if="props.column.field === 'timeTurn'" class="text-nowrap">
                    <div v-for="(item, index) in dataH" :key="index">
                    <span v-if="item._id === props.row._id" class="text-nowrap">
                      <span>{{ item.endTime }} - {{ item.fromTime }}</span>
                    </span>
                  </div>
                  </span>
                  <span v-if="props.column.field === 'nameDr'" class="text-nowrap">
                    <div v-for="(item, index) in dataH" :key="index">
                    <span v-if="item._id === props.row._id" class="text-nowrap">
                      <span>{{ item.planUserId.firstName }}  {{ item.planUserId.lastName }}</span>
                    </span>
                  </div>
                  </span>
                  <span v-if="props.column.field === 'unit'" class="text-nowrap">
                    <div  v-for="(unit, index) in dataH" :key="index">
                      <span v-if="unit._id === props.row._id" class="text-nowrap">
                        <span>{{ unit.unitId.title }} </span>
                      </span>
                    </div>
                  </span>
                  <span v-if="props.column.field === 'user'" class="text-nowrap">
                    <div v-for="(item, index) in dataH" :key="index">
                    <span v-if="item._id === props.row._id" class="text-nowrap">
                      <span>{{ item.createdUserId.firstName }} {{ item.createdUserId.lastName }}</span>
                    </span>
                  </div>
                  </span>
                  <span v-if="props.column.field === 'action'" class="text-nowrap">
                    <span
                      v-if="!props.row.isDeleted && !props.row.updatedMoveAt &&  props.row.isCome === true"
                      class="badge badge-success"
                      >نوبت گرفته شده / مراجعه شده</span
                    >
                    <span
                      v-if="!props.row.isDeleted && !props.row.updatedMoveAt && props.row.isCome === false"
                      class="badge badge-info"
                      >نوبت گرفته شده </span
                    >
                    <span v-if="props.row.isDeleted === true && !props.row.updatedMoveAt" class="badge badge-danger">
                      حذف شده</span
                    >
                    <span v-else-if="props.row.updatedMoveAt" class="badge badge-warning">
                      انتقال داده شده</span
                    >
                    <!-- <span v-if="del">saa</span> -->
                  </span>
                </template>
              </vue-good-table>
            </div>
          </div>
        </div>
</div>
  </div>
</template>

<script>
import {
  BBreadcrumb, BBreadcrumbItem, BRow, BCol, BDropdown, BDropdownItem, BButton,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive';
import { mapGetters } from "vuex";
import {
  BAvatar,
  BBadge,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BAlert,

  BFormCheckbox,
} from "bootstrap-vue";
import { VueGoodTable } from "vue-good-table";
import LegacyModal from "@/components/modal/LegacyModal";
import MyVSelect from "@/components/wrapper/select/MyVSelect";
import moment from "jalali-moment";
export default {
  components: {
    MyVSelect,
    LegacyModal,
    BBreadcrumb,
    BBreadcrumbItem,
    VueGoodTable,
    BAvatar,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BAlert,
    BDropdown,
    BDropdownItem,
    BFormCheckbox,
  },
  props: [
    "planId",
    "timeId",
    "turnOfTimePlanDetailId",
    "isComeStatus",
  ],
  data() {
    return {
      selectedUser: null,
      searchedUserNational: 'both',
      searchedUserGender:"both",
      pageLength: 100,
      page : 1,
      dir: false,
      patientId: "",
      dataH:[],
      dataR:[],
      isCome:false,
      unitTurn:[],
      PatientName:'',
      showModalRefrence:false,
      showModalDrag:false,
      columns: [
        {
          label: "name",
          field: "name",
        },
        // {
        //   label: "username",
        //   field: "username",
        // },
        {
          label: "fathersName",
          field: "fatherName",
        },
        {
          label: "nationalCode",
          field: "nationalCode",
        },
        {
          label: "mobile",
          field: "mobile",
        },
        {
          label: "action",
          field: "action",
        },
      ],
      columnsRefrence: [
        {
          label: "تاریخ نوبت",
          field: "dateTurn",
        },
        {
          label: "زمان نوبت",
          field: "timeTurn",
        },
        {
          label: " نام پزشک",
          field: "nameDr",
        },
        {
          label: "واحد",
          field: "unit",
        },
        {
          label: " عملیات",
          field: "action",
        },
        {
          label: " کاربر",
          field: "user",
        },
        {
          label: " تاریخچه ",
          field: "history",
        },
 
      ],
      searchTerm: "",
      isModalVisible : false,
      genderSelection: [
        {value: "both", text: "خانم و آقا"},
        {value: 'female', text: "خانم"},
        {value: 'male', text: "آقا"},
      ],
      columnsHistory: [
        {
          label: "تاریخ",
          field: "date",
        },
        {
          label: "تاریخ نوبت",
          field: "dateTurn",
        },
        {
          label: "زمان نوبت",
          field: "timeTurn",
        },
        {
          label: " نام پزشک",
          field: "nameDr",
        },
        {
          label: "واحد",
          field: "unit",
        },
        {
          label: " عملیات",
          field: "action",
        },
        {
          label: " کاربر",
          field: "user",
        },
 
      ]
    };
  },

  watch:{
    page(){
      this.searchUser()

      // if (this.searchTerm) {
      //   this.$store.dispatch("patient/searchPatients", { keyword: this.searchTerm ,"page" : parseInt(this.page) , "limit" : parseInt(this.pageLength) ,"roles": [this.patientId] })
      // } else {
      //   this.$store.dispatch("patient/getPatients",{"page" : parseInt(this.page) , "limit" : parseInt(this.pageLength),"roles": [this.patientId] });
      // }

    },
    pageLength(){
      this.page=1
      this.searchUser()
      // let payload = {};
      // this.searchedUserNational ?   payload.userNational = this.searchedUserNational : "";
      // this.searchTerm.length ? (payload.keyword = this.searchTerm) : "";
      // payload.page = parseInt(this.page);
      // payload.limit = parseInt(this.pageLength);
      // payload.roles = [];
      // payload.roles[0] = this.patientId;
      // if (this.searchTerm) {
      //   this.$store.dispatch("patient/searchPatients", { keyword: this.searchTerm,"page" : parseInt(this.page) , "limit" : parseInt(this.pageLength),"roles": [this.patientId]  })
      // } else {
      //   this.$store.dispatch("patient/getPatients",{"page" : parseInt(this.page) , "limit" : parseInt(this.pageLength),"roles": [this.patientId] });
      // }
    }
  },

  directives: {
    Ripple,
  },

  methods: {
    async changeIsCome(row) {
      const payload = {
        timeId: row._id,
        planDetailId: row.createdUserId,
        turnOfTimePlanDetailId: row._id,
        isCome: !this.isCome,
      };
      this.$store
        .dispatch("plan/updateForCome", payload)
        .then((res) => {
          this.$emit("newReserveData", res);
          this.$emit("closeM");
        })
        .catch((error) => {
          let msg = "";
          switch (error.response.status) {
            case 422:
              msg = this.$t("toastification.deletionFailed");
              break;

            case 404:
              msg = this.$t("toastification.deletionFailed");
              break;

            case 400:
              msg = this.$t("toastification.badRequest");
              break;
          }

          this.$bvToast.toast(msg, {
            title: this.$t("toastification.error"),
            variant: "danger",
            solid: true,
          });
        });
    },
    closeModal() {
      this.isModalVisible = false;
    },
    postReferral(user){
      this.$store
          .dispatch("referral/receptionsSearch", {
            patientUserId: user._id,
            status: "done",
          })
          .then((res) => {
            this.$store.commit("referral/SET_POST_REFERRALS", res);
            this.pushBreadcrumb({text:user.firstName + ' ' + user.lastName, translate: false});
            this.pushBreadcrumb({text:'postReferrals', translate: true});
            this.setCurrentBreadcrumb([{text:user.firstName + ' ' + user.lastName, translate: false}, {text:'postReferrals', translate: true}])
            this.$router.push({name: 'patientPostReferrals', params:{id: user._id}})
          });
    },
    legacy(user){
      this.selectedUser = user._id;
      this.$store.commit('SET_IS_LOADING', true);
      this.$store.dispatch('medicalRecord/getMedicalRecord', {
        route: this.$route.name,
        femaleUserId: user._id,
      }).then(res => {
        this.$store.commit('SET_IS_LOADING', false);
        this.isModalVisible = true;
      })
    },
    goToBread(item){
      if (item.to && this.$store.getters['breadcrumb/currentBreadcrumb'].filter(b => {
        return b.text === item.text
      }).length === 0){
        this.$router.push(item.to);
        this.$store.commit('breadcrumb/REMOVE_CURRENT_BREADCRUMB');
        this.$store.commit('breadcrumb/SET_CURRENT_BREADCRUMB', [this.$store.getters['breadcrumb/breadcrumbs'][this.$store.getters['breadcrumb/breadcrumbs'].length-1]]);
      }
    },
    medicalRecord(user, type = "infertility") {
      this.pushBreadcrumb({text:user.firstName + ' ' + user.lastName, translate: false})
      switch (type) {
        case "infertility":
          if (user.gender) {
            if (user.spouses && user.spouses.length) {
              let femaleId = "";
              let maleId = "";
              let relationshipId = user.spouses[0].relationshipId;
              if (user.gender === "female") {
                femaleId = user._id;
                maleId = user.spouses[0].spouseId;
              } else {
                femaleId = user.spouses[0].spouseId;
                maleId = user._id;
              }
              this.$router.push({
                name: type,
                params: {
                  femaleId: femaleId,
                  maleId: maleId,
                  relationshipId: relationshipId,
                },
              });
            } else
              this.$bvToast.toast(
                  this.$t("toastification.spouseNotRegistered"),
                  {
                    title: this.$t("toastification.warning"),
                    variant: "warning",
                    solid: true,
                  }
              );
          } else
            this.$bvToast.toast(this.$t("toastification.genderNotDetect"), {
              title: this.$t("toastification.warning"),
              variant: "warning",
              solid: true,
            });
          break;
        case "genetics":
        case "legal":
        case "nourish":
        case "glands":
        case "obstetric":
          if (user.gender) {
            if (user.spouses && user.spouses.length) {
              let femaleId = "";
              let maleId = "";
              let relationshipId = user.spouses[0].relationshipId;
              if (user.gender === "female") {
                femaleId = user._id;
                maleId = user.spouses[0].spouseId;
              } else {
                femaleId = user.spouses[0].spouseId;
                maleId = user._id;
              }
              this.$router.push({
                name: type,
                params: {
                  femaleId: femaleId,
                  maleId: maleId,
                  relationshipId: relationshipId,
                  gender: user.gender,
                },
              });
            } else {
              let femaleId = 0;
              let maleId = 0;
              let relationshipId = 0;
              if (user.gender === "female") {
                femaleId = user._id;
              } else {
                maleId = user._id;
              }
              this.$router.push({
                name: type,
                params: {
                  femaleId: femaleId,
                  maleId: maleId,
                  relationshipId: relationshipId,
                  gender: user.gender,
                },
              });
            }
          } else
            this.$bvToast.toast(this.$t("toastification.genderNotDetect"), {
              title: this.$t("toastification.warning"),
              variant: "warning",
              solid: true,
            });
          break;
        case "urology":
        case "gynecology":
          if (user.gender) {
            if (user.spouses && user.spouses.length) {
              let femaleId = "";
              let maleId = "";
              let relationshipId = user.spouses[0].relationshipId;
              if (user.gender === "female") {
                femaleId = user._id;
                maleId = user.spouses[0].spouseId;
              } else {
                femaleId = user.spouses[0].spouseId;
                maleId = user._id;
              }
              this.$router.push({
                name: type,
                params: {
                  femaleId: femaleId,
                  maleId: maleId,
                  relationshipId: relationshipId,
                },
              });
            } else {
              let femaleId = 0;
              let maleId = 0;
              let relationshipId = 0;
              if (user.gender === "female") {
                femaleId = user._id;
              } else {
                maleId = user._id;
              }

              if(femaleId === 0 && type === "gynecology"){
                this.$bvToast.toast(this.$t("toastification.patientGender"), {
                  title: this.$t("toastification.warning"),
                  variant: "warning",
                  solid: true,
                });
                return;
              }
              else
              this.$router.push({
                name: type,
                params: {
                  femaleId: femaleId,
                  maleId: maleId,
                  relationshipId: relationshipId,
                },
              });
            }
          } else
            this.$bvToast.toast(this.$t("toastification.genderNotDetect"), {
              title: this.$t("toastification.warning"),
              variant: "warning",
              solid: true,
            });
          break;
        default:
          this.$bvToast.toast(this.$t("toastification.medicalRecordNotFound"), {
            title: this.$t("toastification.warning"),
            variant: "warning",
            solid: true,
          });
          break;
      }
    },
    showReference(row){
      this.$store.commit("SET_IS_LOADING", true);
      const payload = {
        page: parseInt(this.page),
        limit:  parseInt(this.pageLength),
        patientId: row._id
      };
      
      this.$store.dispatch("plan/ReferenceHistory", payload).then((res) => {   
        this.$store.commit("SET_IS_LOADING", false);
        this.dataR = res.data; 
        this.PatientName = row.firstName + " " + row.lastName;
        this.showModalRefrence=true

      });
    },
    CloseReference(){
      this.showModalRefrence=false
    },
    showHistory(row) {   
      this.$store.commit("SET_IS_LOADING", true);
      const payload = {
        planDetailId: row.planDetailId,
        timeId: row.timeId,
        turnOfTimePlanDetailId: row.turnOfTimePlanDetailId
      };
      
      this.$store.dispatch("plan/turnHistory", payload).then((res) => {   
        this.$store.commit("SET_IS_LOADING", false);
        this.total = res.total;
        this.dataH = res; 
        this.PatientName = row.turnUserId.firstName + " " + row.turnUserId.lastName;
        this.showModalDrag = true;

      });

    },
    closeModalHistory(){
      this.showModalDrag = false;

    },
    formatJalaliDate(date) {
      const jalaliDate = moment(date, 'YYYY-M-D').locale('fa').format('jD/jMMMM/jYYYY');
      return jalaliDate;
    },
    formatJalaliDateCreated(date) {
      const jalaliDate = moment(date, 'YYYY-M-D').locale('fa').format('jD/jMMMM/jYYYY');
      return jalaliDate;
    },
    formatJalaliDateUpdated(date) {
      const jalaliDate = moment(date, 'YYYY-M-D').locale('fa').format('jD/jMMMM/jYYYY');
      return jalaliDate;
    },
    searchUser() {
        if (this.searchTerm.length || this.searchedUserNational) {
            let payload = {};
            (this.searchedUserReferralWay !== null) ? payload.referralWayId = this.searchedUserReferralWay : "";
            (this.searchedUserGender !== 'both' && this.searchedUserGender !== null) ? payload.gender = this.searchedUserGender : "";
            (!!this.searchedUserNational) ? payload.userNational = this.searchedUserNational : "";
            this.searchTerm.length ? (payload.keyword = this.searchTerm) : "";
            payload.page = parseInt(this.page);
            payload.limit = parseInt(this.pageLength);
            payload.roles = [];
            payload.roles[0] = this.patientId;
            this.$store.commit('SET_IS_LOADING', true)
            this.$store
                .dispatch("patient/searchPatients", payload)
                .then((res) => {
                    this.$store.commit('SET_IS_LOADING', false)
                    this.$store.commit("patient/SET_PATIENTS", res);
                });
        } else {
            this.getPatients();
        }
        },
        getPatients() {
            this.$store.commit('SET_IS_LOADING', true)
            this.$store.dispatch("patient/getPatients", {
                "page": parseInt(this.page),
                "limit": parseInt(this.pageLength),
                "roles": [this.patientId]
            }).then((res) => {
                this.$store.commit('SET_IS_LOADING', false)
            });
        },
    getPatients() {
      this.$store.commit('SET_IS_LOADING',true)
      this.$store.dispatch("patient/getPatients",{"page" : parseInt(this.page) , "limit" : parseInt(this.pageLength), "roles": [this.patientId]}).then((res) => {
        this.$store.commit('SET_IS_LOADING',false)
        //this.$store.commit("patient/SET_PATIENTS", res);
      });
      // this.$store
      //   .dispatch("patient/getPatients", { roles: [this.patientId] })
      //   .then((res) => {
      //     this.$store.commit("patient/SET_PATIENTS", res);
      //   });
    },

    switchStatus(val, props) {
      val === true ? (props.status = "active") : (props.status = "inactive");
      let payload = {
        // title: props.title,
        //   serviceCategoryId: props.serviceCategoryId._id,
        //   servicePropertyId: props.servicePropertyId._id,
        //   code: props.code,
        status: props.status,
        // position: 0,
        // insurances: props.insurances
      };
      this.$store
        .dispatch("service/updateService", {
          id: props._id,
          payload: payload,
        })
        .then(() => {
          this.$bvToast.toast(this.$t("toastification.submissionSucceed"), {
            // title: this.$t('toastification.success'),
            variant: "success",
            solid: true,
          });
        })
        .catch((error) => {
          this.$bvToast.toast(this.$t("toastification.submissionFailed"), {
            variant: "danger",
            solid: true,
          });
        });
    },
        editPatient(row) {
          // this.$store.commit("user/SET_USER_TO_EDIT", user);
          //   service.insurances.forEach((insurance, index) => {
          //     // console.log(insurance);
          //     // console.log(this.serviceInsurances);
          //     this.serviceInsurances[index].insuranceId = insurance.insuranceId._id;
          //     this.serviceInsurances[index].k.professional = insurance.k.professional;
          //     this.serviceInsurances[index].k.technical = insurance.k.technical;
          //     this.serviceInsurances[index].k.anesthesia = insurance.k.anesthesia;
          //     this.serviceInsurances[index].k.other = insurance.k.other;
          //     // console.log(this.serviceInsurances);
          //   });
          // if (user.addresses && user.addresses.length) {
          //   user.addresses.forEach((address, index) => {
          //     this.addresses[index].address = address.address;
          //     this.addresses[index].cityId = address.cityId;
          //     this.addresses[index].countryId = address.countryId;
          //     this.addresses[index].provinceId = address.provinceId;
          //     this.addresses[index].postalCode = address.postalCode;
          //     this.addresses[index].type = address.type;
          //   });
          // }
          // user.phones.forEach((phone, index) => {
          //   this.phones[index].countryId = phone.countryId;
          //   this.phones[index].phone = phone.phone;
          //   this.phones[index].internal = phone.internal;
          //   this.phones[index].type = phone.type;
          // });
          // user.mobiles.forEach((mobile, index) => {
          //   this.mobiles[index].countryId = mobile.countryId;
          //   this.mobiles[index].mobile = mobile.mobile;
          // });
          this.$router.push({ name: "editPatient", params: { id: row._id } });
        },
     handlePageChange() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
  },
  computed: {
    breadcrumb() {
      return (typeof this.$route.meta.breadCrumb === 'function') ? this.$route.meta.breadCrumb(this.$route) : this.$route.meta.breadCrumb
    },
    ...mapGetters({
      isRtl: "appConfig/isRTL",
      roles: "user/roles",
      femaleMedicalRecord: 'medicalRecord/femaleMedicalRecord',
      userNational: 'user/userNational',
    }),
    patients: {
      set(patients){
        this.$store.commit("patient/SET_PATIENTS", patients);
      },
      get() {
        return this.$store.getters["patient/patients"];
      },
    },
    addresses: {
      set(addresses) {
        this.$store.commit("user/SET_ADDRESSES", addresses);
      },
      get() {
        return this.$store.getters["user/addresses"];
      },
    },
    mobiles: {
      set(mobiles) {
        this.$store.commit("user/SET_MOBILES", mobiles);
      },
      get() {
        return this.$store.getters["user/mobiles"];
      },
    },
    phones: {
      set(phones) {
        this.$store.commit("user/SET_PHONES", phones);
      },
      get() {
        return this.$store.getters["user/phones"];
      },
    },
    total: {
      get() {
        return this.$store.getters["patient/total"];
      },
    },
      units: "units/units",
  },

  created() {
    this.setBreadcrumbs([{text: 'homePage', translate:true, to:{name:'home'}}, {text: 'patientsList', to:{name:'managePatients' }, translate:true}])
    this.setCurrentBreadcrumb([{text: 'patientsList',to:{name:'patientsList' }, translate:true}])
    this.$store.dispatch("user/getRoles").then((res) => {
      this.patientId = this.roles.find((r) => {
        return r.title == "patient";
      })._id;
      // this.getPatients();
      this.searchUser();
    });
    this.$store.dispatch("units/searchUnit", {
      status:"active",
    }).then(res => this.unitTurn=res);
  },
};
</script>

<style scoped>
.custom-search .form-group input{
  border-radius: 5px !important;
} 
.dropdown-menu{
  width:200px !important
}
</style>